import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { getDisplayName } from '../../../../models/NameUtils';
import { bs } from '../../../styles/styles';
import { styleSheet } from './styles';

export const TagAlert: React.FC<{ tag: Api.IAccountTag; onEdit: () => void; isAdminContext?: boolean }> = ({ tag }) => {
	const userSession = useUserSession();
	const interval = tag.tagAlert.interactionIntervalInDays;
	const period = interval % 30 === 0 ? `${interval === 30 ? 'month' : `${interval / 30} months`}` : `${interval} days`;

	let who: string = null;

	if (tag.tagAlert.interactionFilter.accountWide) {
		who = 'Someone from the company';
	} else if (tag.tagAlert.interactionFilter.resourceOwner) {
		who = 'Contact owner';
	} else if (tag?.tagAlert?.interactionFilter?.user?.id === userSession.user.id) {
		who = getDisplayName(tag.tagAlert.interactionFilter.user);
	} else {
		who = 'Unknown';
	}

	return (
		<div className={css(styleSheet.alert)}>
			<div>
				<span className={css(bs.fontBold)}>{who}</span>
				<span> to reach out every </span>
				<span className={css(bs.fontBold)}>{period}</span>
			</div>
		</div>
	);
};
